import styled from "styled-components";
import theme from "../../../Styles/theme";

interface ButtonProps {
  backgroundColor: string;
}
export const Container = styled.button<ButtonProps>`
  width: max(20%,200px);
  
  color: ${theme.colors.light};
  font-size: max(1vw, 14px);
  display: flex;
  align-items:center;
  justify-content:center;
  border-width: 0;
  padding: 0.8vw 0.8vh;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 0.25rem;
  margin-top: 1vh;
`;
